import Report from "components/base/report/Report";
import React from "react";

type ScreenBaseReportType = React.PropsWithChildren<{
	match: {
		params: {
			cnrId: string;
		};
	};
}>;

const ScreenBaseReport: React.FC<ScreenBaseReportType> = (
	props: ScreenBaseReportType
) => {
	return (
		<Report
			cnrId={props.match.params.cnrId}
		/>
	);
};

export default ScreenBaseReport;
